import { Input, Modal } from "antd";
import React, { useEffect, useState } from "react";
import Button from "../common/Button";
import TextArea from "antd/es/input/TextArea";
import { apiCreateWorkItem } from "../../services/WorkItem";
import { ToastFailed, ToastSuccess } from "../common/Toast";
import { apiDetailSite } from "../../services/Site";
import { onBlurInputFormData } from "../../helps/InputData";

export default ({ setPageIndex, isModalOpen, setIsModalOpen, handleGetListWorkItems, siteId, setIsOpenModalSettingSite, setDataDetail }) => {
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        name: "",
        unit: "",
        remark: ""
    })
    const [errors, setErrors] = useState({
        name: "",
        unit: "",
    });

    const handleCancel = async() => {
        if (siteId) {
            const responseDetailSite = await apiDetailSite(siteId)
            if (responseDetailSite?.header?.resultCode === "1000") {
                setDataDetail(responseDetailSite?.records?.site)
            }
            setIsOpenModalSettingSite(true)
        }
        setIsModalOpen(false);
        setFormData({})
    };

    useEffect(() => {
        if (isModalOpen) {
            setFormData({
                name: "",
                unit: "",
                remark: ""
            })
            setErrors({
                name: "",
                unit: "",
            })
        }
    }, [isModalOpen])

    const handleChangeInput = (e, name) => {
        const newFormData = { ...formData };
        newFormData[name] = e.target.value
        setFormData(newFormData)
        setErrors({ ...errors, [name]: "" })
    }

    const handleCreateWorkItem = async () => {
        const newErrors = {
            name: formData.name.trim() ? "" : "Name is required field.",
            unit: formData.unit.trim() ? "" : "Unit is required field.",
        };
        setErrors(newErrors);
        if (!formData.name || !formData.unit) {
            return
        }
        let newFormData = { ...formData }
        if (siteId) {
            newFormData = { ...formData, siteId }
        }
        try {
            setLoading(true)
            const response = await apiCreateWorkItem({ ...newFormData, name: formData.name.trim(), unit: formData.unit.trim(), remark: formData.remark.trim() })
            if (response?.header?.resultCode === "1000") {
                if (siteId) {
                    const responseDetailSite = await apiDetailSite(siteId)
                    if (responseDetailSite?.header?.resultCode === "1000") {
                        setDataDetail(responseDetailSite?.records?.site)
                    }
                    setIsOpenModalSettingSite(true)
                } else {
                    setPageIndex(1)
                }
                handleCancel()
                handleGetListWorkItems()
                ToastSuccess("Work item created successfully.")
            }
        } catch (error) {
            if (error.response) {
                // Access the response object in the error
                if (error.response.data.header?.message?.includes("is exist.")) {
                    setErrors({ ...errors, name: "The work item name already exists in the system; please choose a different name." })
                    ToastFailed("The work item name already exists in the system; please choose a different name.");
                } else {
                    ToastFailed("Work item created failed.")
                }
            } else {
                // Handle other unexpected errors
                ToastFailed("Something went wrong, please try again!");
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal title={"New work item"} open={isModalOpen} footer={null} className='modal-add-new'>
            <div className="add-new-data">
                <div>
                    <div className="d-flex gap-2">
                        <label>Name <span className="text-danger ms-1">*</span></label>
                        <Input
                            value={formData.name}
                            placeholder="Input name"
                            className={`${errors.name ? 'input-error' : ''} w-100`}
                            onChange={(e) => handleChangeInput(e, "name")}
                            onBlur={() => onBlurInputFormData({ formData, setFormData, field: "name" })}
                            maxLength={50} />

                    </div>
                    {errors.name && <div className="text-danger text-error">{errors.name}</div>}
                </div>
                <div>
                    <div className="d-flex gap-2">
                        <label>Unit <span className="text-danger ms-1">*</span></label>
                        <Input
                            placeholder="Input unit"
                            value={formData.unit}
                            onChange={(e) => handleChangeInput(e, "unit")}
                            className={`${errors.unit ? 'input-error' : ''} w-100`}
                            onBlur={() => onBlurInputFormData({ formData, setFormData, field: "unit" })}
                            maxLength={30} />
                    </div>
                    {errors.unit && <div className="text-danger text-error">{errors.unit}</div>}
                </div>
                <div className="d-flex gap-2">
                    <label className="remark">Remark</label>
                    <TextArea rows={3}
                        placeholder="Input remark"
                        value={formData.remark}
                        onChange={(e) => handleChangeInput(e, "remark")}
                        onBlur={() => onBlurInputFormData({ formData, setFormData, field: "remark" })}
                        maxLength={500} />
                </div>
            </div>
            <div className="modal-add-new_footer">
                <Button title={"Save"} width={"62px"} handleClick={handleCreateWorkItem} loading={loading} />
                <Button title={"Cancel"} BgColor={"#fff"} fontColor={"#000000D9"} borderColor={"#D9D9D9"} handleClick={handleCancel} width={"75px"} />
            </div>
        </Modal>
    );
};
